module.exports = __webpack_public_path__ + "img/silver2.4680d97c.png";